exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".styles__editor___2L_a0 {\n  border: solid 1px black;\n  padding: 1rem;\n}\n", "", {"version":3,"sources":["/./src/containers/Editor/styles.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,cAAc;CACf","file":"styles.css","sourcesContent":[".editor {\n  border: solid 1px black;\n  padding: 1rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"editor": "styles__editor___2L_a0"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&sourceMap&importLoaders=2&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/containers/Editor/styles.css
// module id = 506
// module chunks = 0